import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface CopyUrlButtonProps {
	url: string;
	className?: string;
	size?: 'sm' | 'default' | 'lg';
	variant?: 'default' | 'outline' | 'ghost';
}

export function CopyUrlButton({
	url,
	className,
	size = 'sm',
	variant = 'outline',
}: CopyUrlButtonProps) {
	const [copied, setCopied] = useState(false);

	async function handleCopy() {
		try {
			// Try modern clipboard API first
			await navigator.clipboard.writeText(url);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (_err) {
			// Fallback for older browsers
			const textarea = document.createElement('textarea');
			textarea.value = url;
			textarea.style.position = 'fixed';
			textarea.style.opacity = '0';
			document.body.appendChild(textarea);
			textarea.select();
			try {
				document.execCommand('copy');
				setCopied(true);
				setTimeout(() => setCopied(false), 2000);
			} catch (fallbackErr) {
				console.error('Failed to copy URL:', fallbackErr);
			}
			document.body.removeChild(textarea);
		}
	}

	return (
		<Button
			type="button"
			size={size}
			variant={variant}
			onClick={handleCopy}
			className={cn('gap-1.5', className)}
			disabled={copied}
		>
			{copied ? (
				<>
					<Check className="size-3" />
					Copied!
				</>
			) : (
				<>
					<Copy className="size-3" />
					Copy URL
				</>
			)}
		</Button>
	);
}
